import React from 'react';
import { IAncillaryGroup } from '../../../../domain/ancillary/domain/models/IAncillaryGroup';
import { IAncillaryGroupLevel } from '../nested-input';
import { AncillaryGroupCategory } from './AncillaryGroupCategory';
import { AncillaryGroupOptionGroup } from './AncillaryGroupOptionGroup';

interface IAncillaryGroupProps {
	ancillaryGroup: IAncillaryGroup;
	nestedInputLevel: IAncillaryGroupLevel;
}

export const AncillaryGroup = ({
	ancillaryGroup,
	...rest
}: IAncillaryGroupProps) => {
	const shouldShowAncillaryGroupAsCategories = ancillaryGroup.ancillaries.some(
		(ancillary) => ancillary.extras,
	);

	if (shouldShowAncillaryGroupAsCategories) {
		return <AncillaryGroupCategory ancillaryGroup={ancillaryGroup} {...rest} />;
	}

	return (
		<AncillaryGroupOptionGroup ancillaryGroup={ancillaryGroup} {...rest} />
	);
};
